// entrada 2023-01-09T14:14:44.347 => retorno 2023-01-09 14:14:44
export const formatoFecha = (fecha) => {
  if (!fecha) return "";
  if (typeof fecha !== "string") fecha = fecha.toString();

  let arrayFecha = fecha.replace('T', ' ').split('.');
  let fechaFormateada = arrayFecha[0];

  return fechaFormateada;
}

// entrada 2023-01-09T14:14:44.347 => retorno 2023-01-09
export const formatoFechaSinHora = (fecha) => {
  if (!fecha) return "";
  if (typeof fecha !== "string") fecha = fecha.toString()

  let fechaSinHora = fecha.split('T')[0];
  return fechaSinHora;
}